import Styles from "./index.module.scss";
import clsx from "clsx";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import MenuVTC from "../../../Share/Component/MenuVtc";
import { login, accuracy, signup } from "../../../Api/SubUrl";
import useSignUpPage from "../../../Hooks/useSignUpPage";
import { Input } from "../../../Components/Atoms/Input";
import { DateInput } from "../../../Components/Atoms/DateInput";
import { Controller } from "react-hook-form";
import { WarningIcon } from "../../../Components/Atoms/WarningIcon";
import { TERMS_CONTENT, TERMS_MODAL_TITLE } from "./termsContent";

const UNDER_AGE_NOTICE =
  "Bạn chưa đủ 16 tuổi, không thể đăng ký tài khoản. Trường hợp người chơi dưới 16 tuổi thì cha, mẹ hoặc người giám hộ theo pháp luật dân sự đăng ký tài khoản bằng thông tin của cha, mẹ hoặc người giám hộ theo pháp luật dân sự và có trách nhiệm giám sát và quản lý thời gian chơi, nội dung trò chơi của người chơi dưới 16 tuổi truy cập.";

const PHONE_CARRIER_GUIDE = [
  { carrier: "Viettel", prefixes: "032 – 039, 086, 096, 097, 098" },
  { carrier: "VinaPhone", prefixes: "081 – 085, 088, 091, 094" },
  { carrier: "MobiFone", prefixes: "070, 076 – 079, 089, 090, 093" },
  { carrier: "Vietnamobile", prefixes: "052, 056, 058, 092" },
  { carrier: "Gmobile", prefixes: "059, 099" },
];

const NavigationLinks = () => (
  <div className={clsx(Styles.contentLeft)}>
    <div className={clsx(Styles.wrapContent)}>
      <div className={clsx(Styles.wrapOption)}>
        <ul>
          <li>
            <a target="_top" href={login}>
              Đăng nhập
            </a>
          </li>
          <li>
            <a target="_top" href={signup}>
              Đăng ký
            </a>
          </li>
          <li>
            <a target="_top" href={login}>
              Quản lý tài khoản
            </a>
          </li>
          <li>
            <a target="_top" href={accuracy}>
              Quên mật khẩu
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
);

const PasswordInput = ({
  control,
  isShowPassword,
  name,
  label,
  placeholder,
  required = true,
}) => (
  <Controller
    name={name}
    control={control}
    render={({ field, fieldState: { error } }) => (
      <Input
        label={`${label}${required ? " *" : ""}`}
        id={name}
        placeholder={placeholder}
        type={isShowPassword ? "text" : "password"}
        value={field.value}
        onChange={field.onChange}
        error={error}
      />
    )}
  />
);

const ACCOUNT_NAME_COUNT = 4;

const getAccountNameLabel = (index) =>
  index === 0 ? "Tài khoản" : `Tài khoản ${index}`;

const AccountNamesField = ({ control, loading }) => (
  <div className={clsx(Styles.accountNameField)}>
    {Array.from({ length: ACCOUNT_NAME_COUNT }, (_, index) => (
      <Controller
        key={`account-name-${index}`}
        name={`accountNames.${index}`}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <Input
            label={getAccountNameLabel(index)}
            id={`accountName-${index}`}
            placeholder="Độ dài từ 5 đến 10 ký tự. Sử dụng các ký tự: a-z, 0-9"
            value={field.value ?? ""}
            isDisable={loading}
            onChange={(e) => {
              field.onChange(e.target.value.toLowerCase());
            }}
            error={error}
          />
        )}
      />
    ))}
  </div>
);

const SignUpForm = ({
  control,
  isShowPassword,
  handleTogglePassword,
  handleSubmit,
  isLoadReCaptChaV3,
  isDefaultV3,
  reCaptchaV2,
  version,
  idSuccess,
  idFailed,
  isReCaptchaReady,
  loading,
  recaptchaLoading,
  recaptchaError,
  age,
  isUnder16,
  handleGetOtp,
  handleOtpChange,
  otpSentToPhone,
  isSendingOtp,
  onOpenTerms,
}) => (
  <form onSubmit={handleSubmit}>
    <div className={clsx(Styles.title)}>
      <h2>Đăng ký</h2>
      <span className={clsx(Styles.titleHint)}>
        (Có thể đăng ký nhiều tài khoản 1 lúc để không phải lấy OTP nhiều lần)
      </span>
      {isLoadReCaptChaV3 && isDefaultV3 && <p>Đang xác minh . . .</p>}
    </div>
    <div className={clsx(Styles.hr)}></div>

    <AccountNamesField control={control} loading={loading} />

    <div className={clsx(Styles.formRow)}>
      <Controller
        name="fullName"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <Input
            label="Họ và tên *"
            id="fullName"
            placeholder="Nhập họ và tên"
            value={field.value}
            onChange={field.onChange}
            error={error}
          />
        )}
      />

      <Controller
        name="dateOfBirth"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <DateInput
            label="Ngày sinh *"
            id="dateOfBirth"
            value={field.value}
            onChange={field.onChange}
            error={isUnder16 ? undefined : error}
          />
        )}
      />
    </div>

    {age !== null && isUnder16 && (
      <div className={clsx(Styles.ageNotice)} role="alert">
        <span className={clsx(Styles.ageNoticeIcon)} aria-hidden="true">
          <WarningIcon size={40} />
        </span>
        <p className={clsx(Styles.ageNoticeText)}>{UNDER_AGE_NOTICE}</p>
      </div>
    )}

    <Controller
      name="phoneNumber"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div className={clsx(Styles.phoneFieldGroup)}>
          <Input
            label={
              <>
                Số điện thoại *{" "}
                <span className={clsx(Styles.phoneLabelHint)}>
                  (Mã OTP sẽ được gửi tới SĐT bên dưới)
                </span>
              </>
            }
            id="phoneNumber"
            placeholder="Nhập số điện thoại Việt Nam"
            value={field.value}
            onChange={field.onChange}
            error={error}
          />
          <button
            type="button"
            className={clsx(Styles.getOtpButton)}
            onClick={handleGetOtp}
            disabled={isSendingOtp || loading}
          >
            {isSendingOtp ? "Đang gửi..." : "Lấy OTP"}
          </button>
          {error && (
            <div className={clsx(Styles.phoneGuide)}>
              <p className={clsx(Styles.phoneGuideTitle)}>
                Số điện thoại gồm 10 chữ số (hoặc +84 và 9 chữ số), đầu số theo
                nhà mạng:
              </p>
              <ul className={clsx(Styles.phoneGuideList)}>
                {PHONE_CARRIER_GUIDE.map(({ carrier, prefixes }) => (
                  <li key={carrier}>
                    <strong>{carrier}:</strong> {prefixes}
                  </li>
                ))}
              </ul>
              <p className={clsx(Styles.phoneGuideExample)}>
                Ví dụ: 0912345678 hoặc +84912345678
              </p>
            </div>
          )}
          {otpSentToPhone && (
            <p className={clsx(Styles.phoneOtpNotice)}>
              Không thể gửi mã OTP qua SMS.
              <br />
              Vui lòng kiểm tra tin nhắn Zalo để lấy mã xác thực.
            </p>
          )}
        </div>
      )}
    />

    {(version === "2" || !isDefaultV3) && (
      <div className={clsx(Styles.recaptchaContainer)}>
        <div
          id="recaptcha123"
          className={clsx(Styles.recaptcha)}
          ref={reCaptchaV2}
        ></div>

        {recaptchaLoading && (
          <div className={clsx(Styles.recaptchaLoading)}>
            <p>Đang tải reCAPTCHA...</p>
          </div>
        )}

        {recaptchaError && (
          <div className={clsx(Styles.recaptchaError)}>
            <p>{recaptchaError}</p>
            <button
              type="button"
              className={clsx(Styles.reloadBtn)}
              onClick={() => window.location.reload()}
            >
              Tải lại
            </button>
          </div>
        )}
      </div>
    )}

    <Controller
      name="otp"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div className={clsx(Styles.otpFieldGroup)}>
          <div className={clsx(Styles.otpLabelRow)}>
            <label className="label" htmlFor="otp">
              Mã OTP *
            </label>
            {otpSentToPhone && (
              <span className={clsx(Styles.otpSentMessage)}>
                {`(đã được gửi tới số ${otpSentToPhone})`}
              </span>
            )}
          </div>
          <Input
            label=""
            id="otp"
            placeholder="Nhập mã OTP"
            value={field.value}
            onChange={(e) => handleOtpChange(e.target.value, field.onChange)}
            error={error}
          />
        </div>
      )}
    />

    <PasswordInput
      control={control}
      isShowPassword={isShowPassword}
      name="password"
      label="Mật khẩu"
      placeholder="Độ dài từ 6 đến 32 ký tự"
    />

    <PasswordInput
      control={control}
      isShowPassword={isShowPassword}
      name="rePassword"
      label="Xác nhận mật khẩu"
      placeholder="Độ dài từ 6 đến 32 ký tự"
    />

    <PasswordInput
      control={control}
      isShowPassword={isShowPassword}
      name="secPassword"
      label="Mật khẩu cấp 2"
      placeholder="Độ dài từ 6 đến 32 ký tự"
      required={false}
    />

    <div className={clsx(Styles.showPass)}>
      <input
        type="checkbox"
        checked={isShowPassword}
        onChange={() => handleTogglePassword(!isShowPassword)}
      />
      <p onClick={() => handleTogglePassword(!isShowPassword)}>Hiện mật khẩu</p>
    </div>

    <Controller
      name="agreeTerms"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div className={clsx(Styles.agreeTerms)}>
          <label className={clsx(Styles.agreeTermsLabel)} htmlFor="agreeTerms">
            <input
              id="agreeTerms"
              type="checkbox"
              checked={Boolean(field.value)}
              onChange={(e) => field.onChange(e.target.checked)}
            />
            <span className={clsx(Styles.agreeTermsText)}>
              Tôi đã đọc và đồng ý với{" "}
              <button
                type="button"
                className={clsx(Styles.agreeTermsLink)}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onOpenTerms?.();
                }}
              >
                Điều khoản Dịch vụ
              </button>{" "}
              và{" "}
              <button
                type="button"
                className={clsx(Styles.agreeTermsLink)}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onOpenTerms?.();
                }}
              >
                Chính sách
              </button>
            </span>
          </label>
          {error?.message && (
            <span className={clsx(Styles.agreeTermsError)}>{error.message}</span>
          )}
        </div>
      )}
    />

    <div className={clsx(Styles.formGroup)}>
      <a className={clsx(Styles.forgetPass)} target="_top" href={login}>
        Bạn đã có tài khoản?
      </a>
    </div>

    <div className={clsx(Styles.formGroup)}>
      <div className={clsx(Styles.btnSubmit)}>
        <button
          type="submit"
          className={clsx(
            Styles.btn,
            (loading || isSendingOtp || (isLoadReCaptChaV3 && isDefaultV3)) &&
              Styles.btnDisabled
          )}
          disabled={loading || isSendingOtp || (isLoadReCaptChaV3 && isDefaultV3)}
        >
          {loading ? "Đang xử lý..." : "Đăng ký"}
        </button>

        {(!isReCaptchaReady || isLoadReCaptChaV3) && isDefaultV3 && (
          <p className={clsx(Styles.verifyingText)}>Đang xác minh . . .</p>
        )}

        {(idSuccess?.length > 0 || idFailed?.length > 0) && (
          <div className={clsx(Styles.resultMessages)}>
            {idSuccess?.length > 0 && (
              <p className={clsx(Styles.success)}>
                ID{" "}
                <span>
                  {Array.isArray(idSuccess) ? idSuccess.join(", ") : idSuccess}
                </span>{" "}
                đăng ký thành công!
              </p>
            )}
            {idFailed?.map((item) => (
              <p key={item.accountName} className={clsx(Styles.fail)}>
                ID <span>{item.accountName}</span> đăng ký thất bại
                {item.message ? `: ${item.message}` : "!"}
              </p>
            ))}
          </div>
        )}
      </div>
    </div>
  </form>
);

function Signup() {
  const {
    version,
    reCaptchaV2,
    isReCaptchaReady,
    isLoadReCaptChaV3,
    isShowPassword,
    control,
    loading,
    recaptchaLoading,
    recaptchaError,
    idSuccess,
    idFailed,
    age,
    isUnder16,
    handleTogglePassword,
    handleGetOtp,
    handleOtpChange,
    otpSentToPhone,
    isSendingOtp,
    handleSubmit,
    isDefaultV3,
  } = useSignUpPage();
  const [showTermsModal, setShowTermsModal] = useState(false);

  return (
    <div className={clsx(Styles.main, "flex-grow-1")}>
      <div className={clsx(Styles.contentMain)}>
        <NavigationLinks />

        <div className={clsx(Styles.contentCenter)}>
          <div className={clsx(Styles.iframeId)}>
            <div className={clsx(Styles.wrapIframe)}>
              <div className={clsx(Styles.form)}>
                <SignUpForm
                  control={control}
                  isShowPassword={isShowPassword}
                  handleTogglePassword={handleTogglePassword}
                  handleGetOtp={handleGetOtp}
                  handleOtpChange={handleOtpChange}
                  otpSentToPhone={otpSentToPhone}
                  isSendingOtp={isSendingOtp}
                  handleSubmit={handleSubmit}
                  isLoadReCaptChaV3={isLoadReCaptChaV3}
                  isDefaultV3={isDefaultV3}
                  reCaptchaV2={reCaptchaV2}
                  version={version}
                  idSuccess={idSuccess}
                  idFailed={idFailed}
                  isReCaptchaReady={isReCaptchaReady}
                  loading={loading}
                  recaptchaLoading={recaptchaLoading}
                  recaptchaError={recaptchaError}
                  age={age}
                  isUnder16={isUnder16}
                  onOpenTerms={() => setShowTermsModal(true)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <MenuVTC />

      <Modal
        show={showTermsModal}
        onHide={() => setShowTermsModal(false)}
        centered
        size="lg"
        scrollable
        dialogClassName={clsx(Styles.termsModalDialog)}
        contentClassName={clsx(Styles.termsModalContent)}
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          className={clsx(Styles.termsModalHeader)}
        >
          <Modal.Title>{TERMS_MODAL_TITLE}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={clsx(Styles.termsModalBody)}>
          {TERMS_CONTENT.map((block, index) => {
            if (block.type === "title") {
              return (
                <p
                  key={`title-${index}`}
                  className={clsx(Styles.termsSectionTitle)}
                >
                  {block.text}
                </p>
              );
            }

            if (block.type === "ul") {
              return (
                <ul key={`ul-${index}`} className={clsx(Styles.termsList)}>
                  {block.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              );
            }

            return <p key={`p-${index}`}>{block.text}</p>;
          })}
        </Modal.Body>
        <Modal.Footer className={clsx(Styles.termsModalFooter)}>
          <button
            type="button"
            className={clsx(Styles.termsModalCloseBtn)}
            onClick={() => setShowTermsModal(false)}
          >
            Đóng
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Signup;
